import { openModal } from 'components/Modal';
import { connect } from 'react-redux';
import { selectActiveMsInventoryVenue } from 'selectors/general';
import SelectClassInput from './SelectClassInput';

export const mapStateToProps = (state, ownProps) => {
  const { id: activeVenueId } = selectActiveMsInventoryVenue(state);
  const { classes, ...restOwnProps } = ownProps;
  const sortedClasses = !activeVenueId
    ? classes
    : classes.sort((c1, c2) => {
        const isC1UsedByActiveVenue = c1.scheduleVenueIds.includes(activeVenueId);
        const isC2UsedByActiveVenue = c2.scheduleVenueIds.includes(activeVenueId);
        if (isC1UsedByActiveVenue && !isC2UsedByActiveVenue) {
          return -1;
        }
        if (!isC1UsedByActiveVenue && isC2UsedByActiveVenue) {
          return 1;
        }
        return 0;
      });
  return {
    ...restOwnProps,
    classes: sortedClasses,
  };
};

const mapDispatchToProps = {
  onAddClassClick: openModal.bind(null, 'AddClassModal'),
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectClassInput);
